import { Component } from '@angular/core';

@Component({
    selector: 'ohp-left-nav-react',
    templateUrl: './left-nav-react.component.html'
})
export class LeftNavReactComponent {
}
